import React from "react";
import "./form-layout.css";

export default function FormSection({ title, children, action, className = "" }) {
  const hasBody = React.Children.toArray(children).length > 0;
  return <section className={`admin-form-section ${className}`} data-empty={!hasBody}>
    <div className={`admin-form-section-heading${action ? " has-action" : ""}`}><h2>{title}</h2>{action}</div>
    {children}
  </section>;
}
